module.exports = __webpack_public_path__ + "media/images/products/trial-mobile-7bf0750a299012d9647f254f4987e37d.png";